import styled from "styled-components";
import media from "styled-media-query";

import bg from '../../assets/bg-stars.jpg'
import plus from '../../assets/icon-plus.svg';
import less from '../../assets/icon-less.svg';

export const SectionDoubts = styled.section`
  z-index: 2;
  background-image: url(${bg});
  background-size: cover;
  background-attachment: fixed;
  color: #fff;
  padding-top: 75px;
  position: relative;

  ${media.lessThan('1366px')`
    padding-top: 55px;
  `}

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.25);
    z-index: -1;
  }

  ${media.lessThan('1024px')`
    padding-top: 24px;
  `}

  h2{
    font-family: 'Poppins';
    font-weight: 700;
    font-size: 56px;
    line-height: 67px;

    padding-left: 24px;
    align-self: flex-start;

    ${media.lessThan('1366px')`
      font-size: 40px;
    `}

    ${media.lessThan('1024px')`
      font-size: 28px;
      padding-left: 21px;
    `}
  }

  .container {
    display: flex;
    align-items: center;
    flex-direction: column;
    ${media.lessThan('1366px')`
      max-width: 980px;
    `}
  }

  .doubts {
    margin: 55px 0;
    width: 100%;
    padding: 0 13px 0 24px;

    ${media.lessThan('1366px')`
      margin: 40px 0;
    `}

    ${media.lessThan('1024px')`
      margin: 33px 0;
    `}

    details {
      summary {
        list-style: none;
      }

      & + details {
        margin-top: 17px;
        ${media.lessThan('1366px')`
          margin-top: 12px;
        `}
      }
    }

    .collapse {
      &[open] {
        .title {
          background: #144BC8;
          &:after {
            content: url(${less});
            padding-bottom: 15px;
          }
        }
      }
    }

    .title {
      cursor: pointer;
      position: relative;
      padding: 44px 33px;
      background: rgba(217, 230, 252, 0.2);
      border-radius: 8px;

      font-family: 'Poppins';
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
      line-height: 28px;

      ${media.lessThan('1366px')`
        font-size: 16px;
        line-height: 16px;
        padding: 34px 23px;
      `}

      ${media.lessThan('1024px')`
        font-size: 18px;
        line-height: 28px;
        padding: 26px 54px 26px 22px;
      `}
      
      &:after {
        content: url(${plus});
        position: absolute;
        width: 16px;
        height: 16px;
        right: 36px;
        transform: translatey(-50%);
        top: 50%;

        ${media.lessThan('1024px')`
          right: 30px
        `}
      }

      span {
        display: block;
        min-width: 250px;
        max-width: 850px;
        padding-right: 16px;
      }
    }

    .description {
      margin-top: -10px;
      padding: 43px 51px 34px 33px;
      background: rgba(217, 230, 252, 0.2);
      border: 1px solid rgba(217, 230, 252, 0.2);
      border-radius: 0 0 8px 8px;

      a {
        text-decoration: underline;
      }

      ${media.lessThan('1366px')`
        padding: 33px 41px 24px 23px;
      `}

      ${media.lessThan('1024px')`
        padding: 28px 28px 28px 23px;
      `}

      p {
        font-family: 'Open Sans', sans-serif;
        font-size: 16px;
        line-height: 24px;
        color: #D9E6FC;
        & + p {
          margin-top: 32px;
        }

        ${media.lessThan('1366px')`
          font-size: 14px;

          & + p {
            margin-top: 16px;
          }
        `}
      }
    }
  }

  button {
    margin-bottom: 80px;

    ${media.between('1024px', '1366px')`
      height: 56px;
      font-size: 16px;
    `}
  }
`